import React from 'react';
import { MapMailItemThumbnailsType } from './Types/ThumbnailTypes';
import { MapSingleMailItemThumbnail } from './MapSingleMailItemThumbnail';
import { MailItemNoThumbnail } from './Entries/MailItemNoThumbnail';
import { MailItemTopUpRequiredThumbnail } from './Entries/MailItemTopUpRequiredThumbnail';

function MapMailItemThumbnails(props: MapMailItemThumbnailsType) {
	const MappedThumbnailCollection = props.files?.flatMap((file) => {
		if (file.mailPart !== props.mailType) return [];

		return (
			<MapSingleMailItemThumbnail
				key={`mailItem-${props.mailType}-Thumb`}
				file={file}
				mailType={props.mailType}
				hideMissing={props.hideMissing}
				size={props.size}
				onClickCallback={props.onClickCallback}
			/>
		);
	});

	if (MappedThumbnailCollection?.length === 0 && !props.hideMissing) {
		if (props.files[0]?.topupRequired) {
			return <MailItemTopUpRequiredThumbnail size={props.size} />;
		}

		return <MailItemNoThumbnail mailType={props.mailType} size={props.size} />;
	}

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{MappedThumbnailCollection}</>;
}

export { MapMailItemThumbnails };
